/*
 * 공통 함수
 */

// ============== //
/*
 * ===== gtag =====
 */

// 광고 gtag 생성 이벤트 함수
export function trackClick(
	// eventName: 'festival'|'product', // 이벤트명
	eventName,
	id, // 아이디
	location // 위치
) {
	if (typeof window !== "undefined") {
		window.setTimeout(() => {
			if (typeof window !== "undefined" && window.gtag)
				window.gtag("event", `${eventName}_click`, {
					//
				});
		}, 1000);
	}
}
// 광고 gtag 생성 이벤트 함수
export function trackAd(eventName, adCategory, adPositionName, adID) {
	if (typeof window !== "undefined") {
		window.setTimeout(() => {
			if (typeof window !== "undefined" && window.gtag)
				window.gtag("event", eventName, {
					ad_category: adCategory,
					ad_position_name: adPositionName,
					ad_ID: adID,
				});
		}, 1000);
	}
}

// 광고 새창열기
export function openUrlByApp(url) {
	if (window.appInfo && window.appInfo.os) {
		try {
			if (window.appInfo.os === "iOS") {
				window.webkit.messageHandlers.openUrl.postMessage(url);
				return;
			} else if (window.appInfo.os === "Android" && window.AppInfo) {
				window.AppInfo.openUrl(url);
				return;
			}
		} catch (e) {
			console.error(e);
		}
	}
	window.open(url, "_blank");
}

/*
 * ===== gtag =====
 */

/**
 *
 * @param {object} data
 * @returns 상품 종류 문자 반환
 */
export const SET_MENU_TYPE = (data) => {
	switch (data?.mode) {
		// ===== 일반상품 =====
		case "NORMAL":
			switch (data?.normalInfo?.optionMode) {
				case "TOP":
					return "NORMAL_TOP"; // 필수 옵선 상품
				case "SELECT":
					return "NORMAL_SELECT"; // 선택 옵션 상품
				default:
					return "NORMAL"; // 일반 상품
			}

		// ===== 시간상품 =====
		case "TIME":
			switch (data?.timeInfo?.type) {
				case "TYPE":
					return "TIME_OPTION"; // 종류형 시간 상품 (시간+옵션)
				default:
					return "TIME"; // 단일형 시간 상품
			}
	}
};

/*
 * 문자열 중 첫글자를 대문자로 변경하는 함수
    - 각 언어별 key값을 위해 사용
    - ex) menu[KoKr]
 */
export const FIRST_ST_TO_UPPER = (s) => {
	const upperSt = s.replace(/^\w/, (c) => c.toUpperCase());

	return upperSt;
};

/**
 * 언어별 금액 표기
 * @param {number} price : 금액
 * @param {string} lg : 기준 언어
 * @returns 언어에 맞는 금액표기
 * ex) 2,000원 / 2,000KRW
 */
export const SET_PRICE_CURRENCY = (price, lg) => {
	let p = 0;

	switch (lg) {
		case "koKr":
			p = `${Number(price).toLocaleString()}원`;
			break;
		default:
			p = `${Number(price).toLocaleString()}KRW`;
	}

	return p;
};

/**
 * 리스트 순서 오름차순 정렬
 * @param {object[]} dataList : 기존 리스트
 * @param {string} sortKey : 변경순서 기준값
 * @param {string} optionKey : 기준값이 같을때 비교할 키값
 * @returns 순서 변경된 리스트
 */
export const ASC_SORT = (dataList, sortKey, optionKey) => {
	const arr = dataList.sort((a, b) => {
		if (a[sortKey] === b[sortKey]) {
			return a[optionKey] - b[optionKey];
		}
		return a[sortKey] - b[sortKey];
	});

	return arr;
};

// ============== //
